module.exports = __webpack_public_path__ + "static/media/bat_exec.8bb01c24.ico";